import { useMainStore } from '@/stores/mainStore';

/**
 * Service de gestion des équipes et inscriptions d'équipe
 * Responsable de la gestion des équipes et des inscriptions d'équipe
 */
class TeamService {
    constructor() {
        // Le service est un singleton
    }

    /**
     * Gère les équipes créées et ajoute les inscriptions manquantes si nécessaire
     * 
     * @param {Array} equipes - Liste des équipes créées
     * @param {Object} bookingStore - Le store de réservation
     */
    handleCreatedTeams(equipes, bookingStore) {
        if (equipes.length == 0) return;
        const nb_inscriptions_required = equipes.reduce((acc, equipe) => acc + equipe.size, 0);
        const nb_inscriptions_current = bookingStore.inscriptions.length;
        if (nb_inscriptions_required <= nb_inscriptions_current) {
            return;
        }
        const nb_inscriptions_per_course = equipes.reduce((acc, equipe) => {
            if (!acc[equipe.id_course]) {
                acc[equipe.id_course] = 0;
            }
            acc[equipe.id_course] += equipe.size;
            return acc;
        }, {});

        // parcourir nb_inscriptions_per_course et pour chaque id_course, ajouter les inscriptions manquantes
        for (let id_course in nb_inscriptions_per_course) {
            const nb_inscriptions_with_id_course = bookingStore.inscriptions.filter((inscription) => inscription.get_selected_course_id() == id_course).length;
            this.addMissingInscriptionToCompleteTeam(bookingStore, id_course, nb_inscriptions_with_id_course, nb_inscriptions_per_course[id_course]);
        }
    }

    /**
     * Ajoute les inscriptions manquantes pour compléter une équipe
     * 
     * @param {Object} bookingStore - Le store de réservation
     * @param {number} id_course - L'ID de la course
     * @param {number} nb_inscriptions_with_id_course - Nombre d'inscriptions actuelles pour cette course
     * @param {number} nb_inscriptions_per_course - Nombre d'inscriptions requises pour cette course
     */
    addMissingInscriptionToCompleteTeam(bookingStore, id_course, nb_inscriptions_with_id_course, nb_inscriptions_per_course) {
        const mainStore = useMainStore();

        if (nb_inscriptions_with_id_course >= nb_inscriptions_per_course) {
            return;
        }
        const nb_inscriptions_to_add = nb_inscriptions_per_course - nb_inscriptions_with_id_course;
        for (let i = 0; i < nb_inscriptions_to_add; i++) {
            const lock_selection_parcours = true;
            bookingStore.addInscription(id_course, lock_selection_parcours);
        }
        const message = "Ajout automatique de " + nb_inscriptions_to_add + " inscriptions pour compléter l'équipe";
        mainStore.notification.send(message, "success");
    }

    /**
     * Supprime les inscriptions d'une équipe
     * 
     * @param {Object} bookingStore - Le store de réservation
     * @param {Object} equipe - L'équipe contenant les coureurs à supprimer
     */
    deleteInscriptionsFromEquipe(bookingStore, equipe) {
        //order equipe coureur by index
        equipe.coureurs.sort((a, b) => a.index - b.index);
        for (let i = equipe.coureurs.length - 1; i >= 0; i--) {
            bookingStore.inscriptions.splice(equipe.coureurs[i].index, 1);
        }
    }
}

export default new TeamService();
